<template>
  <li
    class="nav-item parent"
    :class="{ 'has-active-child': hasActiveChild }"
  >
    <SidebarLink
      :item="item"
      :empty="children.length > 0"
      :force-active="hasActiveChild"
      :class="{ open: isOpen }"
      @open="openItem"
    />
    <div
      v-if="children.length"
      class="sidebar-submenu"
      :class="{ 'sidebar-submenu--open': isOpen }"
      :aria-hidden="!isOpen"
    >
      <div class="sidebar-submenu__inner">
        <ul class="list-unstyled mb-0">
          <li
            v-for="child in children"
            :key="child.id || child.name"
            class="children"
          >
            <SidebarLink :item="child" />
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script setup>
import { computed, shallowRef, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui'
import { useUserStore } from '@/stores/user.js'
import { canViewSidebarRoute } from '@/lib/routeAccess'
import { isSidebarParentActive } from '@/lib/sidebarActive'
import SidebarLink from '@/components/sidebar/sidebarLink.vue'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})

const isOpen = shallowRef(false)
const route = useRoute()
const router = useRouter()
const { sidebarIconOnly } = storeToRefs(useUiStore())
const userStore = useUserStore()

const children = computed(
  () =>
    (props.item?.children || []).filter(lnk => canViewSidebarRoute(lnk, userStore)) || []
)

const hasActiveChild = computed(() =>
  isSidebarParentActive(
    route.name,
    children.value.map(child => child.name)
  )
)

watch(
  hasActiveChild,
  active => {
    if (active) {
      isOpen.value = true
    }
  },
  { immediate: true }
)

function openItem() {
  if (!sidebarIconOnly.value) {
    isOpen.value = !isOpen.value
    return
  }

  sidebarIconOnly.value = false
  isOpen.value = true

  const firstChild = children.value[0]
  if (firstChild?.name) {
    router.push({ name: firstChild.name }).catch(() => {})
  }
}
</script>
